import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: 0 }} p={3}>
          {children}
        </Box>
      )}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90%',
  },
  appBar: {
    margin: '22px 0 47px 0',
    borderRadius: '5px',
    backgroundColor: '#fff',
    boxShadow: 'none',
    border: '1px solid lightgray',
  },
}));

export default function ActivityTabs(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = index => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <AppBar className={classes.appBar} position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label="Atividade" {...a11yProps(0)} />
          <Tab label="Card" {...a11yProps(1)} />
          {(props.typeAction === 9 ||
            props.typeAction === 10 ||
            props.typeAction === 11 ||
            props.typeAction === 12) && (
            <Tab label="Interação" {...a11yProps(2)} />
          )}
        </Tabs>
      </AppBar>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        <TabPanel value={value} index={0} dir={theme.direction}>
          {props.activity}
        </TabPanel>
        <TabPanel value={value} index={1} dir={theme.direction}>
          {props.card}
        </TabPanel>
        {(props.typeAction === 9 ||
          props.typeAction === 10 ||
          props.typeAction === 11 ||
          props.typeAction === 12) && (
          <TabPanel value={value} index={2} dir={theme.direction}>
            {props.interaction}
          </TabPanel>
        )}
      </SwipeableViews>
    </div>
  );
}
